<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getFatture()"> Contabilità </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1">{{ tab == 1 ? 'Fatture di acquisto' : 'Fatture di vendita' }}</span>
				</h4>
			</div>
			<div class="d-lg-block my-lg-auto ms-lg-auto text-center">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2" style="text-align: left;" v-if="$root.hasFunzionalita('FATTURAZIONE_CREATE')" v-on:click.prevent="nuovaFattura()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">Nuova Fattura</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>
				</div>
			</div>
		</div>

		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" :class="tab == 1 ? 'active' : ''" v-on:click.prevent="cambiaTab(1)">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-arrow-circle-down"></i>
								<span class="hidden-lg ms-1">Acquisto</span>
								<span class="hidden-xs ms-1">Fatture di acquisto</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a href="#" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" :class="tab == 2 ? 'active' : ''" v-on:click.prevent="cambiaTab(2)">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-arrow-circle-up"></i>
								<span class="hidden-lg ms-1">Vendita</span>
								<span class="hidden-xs ms-1">Fatture di vendita</span>
							</div>
						</a>
					</li>
				</ul>
				<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
					<li class="nav-item dropdown ms-lg-1">
						<div class="btn-group">
							<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
								<i class="ph-gear me-1"></i><span style="font-size:0.8rem;"><Translate :path="'dizionario.base.AZIONI_MULTIPLE'"></Translate></span>
							</a>
							<div class="dropdown-menu dropdown-menu-end">
								<div class="dropdown-submenu dropdown-submenu-start" v-if="$root.hasFunzionalita('FATTURAZIONE_EXPORT')">
									<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
									<div class="dropdown-menu">
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')"><i class="far fa-file-export fa-fw me-2"></i>Pagina corrente</a>
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')"><i class="far fa-file-export fa-fw me-2"></i>Fatture selezionate</a>
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')"><i class="far fa-file-export fa-fw me-2"></i>Tutte le fatture</a>
									</div>
								</div>
								<div class="dropdown-divider"></div>
								<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('FATTURAZIONE_DELETE')" @click.prevent="eliminaSelezionate()">
									<i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.ELIMINA_SELEZIONATI'"></Translate>
								</a>
								<a href="#" class="dropdown-item" v-if="$root.isGod && arrayFatture.some(f => f.SELEZIONATO == 1 && f.FLG_ELIMINATO == 1)" @click.prevent="ripristinaSelezionate()">
									<i class="fad fa-redo fa-fw me-2 text-success"></i><span class="text-muted me-1">|</span>Ripristina selezionate
								</a>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- /page header -->

	<div class="content content-1 table-cms-wrapper">
		<div class="row g-2 mb-2">
			<div class="col-6 col-xl-3" v-for="k in kpi" :key="k.label">
				<KpiCard :label="k.label" :icona="k.icona" :tema="k.tema" :indicatore="{ valore: k.valore, unita: 'EUR' }" :nota="k.nota" />
			</div>
		</div>

		<div class="card shadow mb-xs-3 mb-lg-0">
			<div class="card-body pb-0">
				<div class="alert alert-2 alert-secondary border-0">
					<div class="row">
						<div class="col-6 col-md-1 mbx-1">
							<select class="form-select form-select-sm" v-model="anno" @change="getFatture()">
								<option v-for="a in anni" :key="a" :value="a">{{ a }}</option>
							</select>
						</div>
						<div class="col-12 col-md-3 mbx-1">
							<SelectIntestatario v-model:pg="filtroPg" v-model:pf="filtroPf" :api-aziende="apiAziende" :placeholder="'Tutti'" @change="getFatture()"></SelectIntestatario>
						</div>
						<div class="col-6 col-md-2 mbx-1">
							<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Numero" v-model="search.NUMERO.VALUE" />
						</div>
						<div class="col-6 col-md-3 mbx-1">
							<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Descrizione" v-model="search.DESCRIZIONE.VALUE" />
						</div>
						<div class="col-6 col-md-2 mbx-1">
							<select class="form-select form-select-sm" v-model="search.FLG_ATTIVO.VALUE">
								<option value="">Tutte</option>
								<option value="1">Attive</option>
								<option value="0">Non attive</option>
							</select>
						</div>
						<div class="col-1 col-md-1 mbx-1 ps-0" v-if="$root.isGod">
							<a href="#collapse-fatture" class="btn btn-flat-info btn-sm w-100 collapsed" data-bs-toggle="collapse" @click.prevent="filters.resizeGrid('collapse-fatture','tableFixHead','box-card')" role="button" aria-expanded="false">S</a>
						</div>
					</div>
					<div class="collapse" id="collapse-fatture" v-if="$root.isGod">
						<div class="row">
							<div class="col-12 col-md-2 mt-1">
								<select class="form-select form-select-sm" v-model="eliminati" @change="getFatture()">
									<option value="0">Non eliminate</option>
									<option value="2">Tutte</option>
									<option value="1">Eliminate</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card-body box-card mt-0 mb-0" id="box-card">
				<div class="div_table_resp tableFixHead" id="tableFixHead">
					<table class="table table-bordered table-hover table-striped text-nowrap">
						<thead class="sticky-top">
							<tr class="bg-secondary text-white">
								<th class="table-head-sm text-center" style="width: 2%;"><input id="chkAllFatture" type="checkbox" v-on:click="filters.selectAll('chkAllFatture', paginatedList.arr)"></th>
								<th class="table-head-sm text-center" style="width: 8%;">Data</th>
								<th class="table-head-sm" style="width: 8%;">Numero</th>
								<th class="table-head-sm" style="width: 18%;">Intestatario</th>
								<th class="table-head-sm">Descrizione</th>
								<th class="table-head-sm text-end" style="width: 9%;">Netto</th>
								<th class="table-head-sm text-end" style="width: 8%;">IVA</th>
								<th class="table-head-sm text-end" style="width: 9%;">Totale</th>
								<th class="table-head-sm text-end" style="width: 9%;">Associato</th>
								<th class="table-head-sm text-center" style="width: 8%;">Da associare</th>
								<th class="table-head-sm text-center" style="width: 7%;" v-if="tab == 1">Scadenze</th>
								<th class="table-head-sm text-center" style="width: 5%;"><Translate :path="'dizionario.base.AZIONI'"></Translate></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="f in paginatedList.arr" v-bind:key="f.ID_FATTURA" :class="{ 'table-danger text-muted': f.FLG_ELIMINATO == 1 }">
								<td class="td-class text-center"><input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="f.SELEZIONATO"></td>
								<td class="td-class text-center fs-sm">{{ f.DATA_FATTURA_IT }}</td>
								<td class="td-class fs-sm fw-semibold">{{ f.NUMERO }} <a v-if="f.FILE_ALLEGATO" href="#" class="text-primary ms-1" :title="f.NOME_FILE" @click.prevent="visualizzaAllegato(f)"><i class="ph-paperclip"></i></a> <span v-if="f.FLG_ATTIVO == 0" class="badge bg-secondary ms-1">Non attiva</span><span v-if="f.FLG_ELIMINATO == 1" class="badge bg-danger ms-1">Eliminata</span></td>
								<td class="td-class fs-sm" style="max-width: 0;"><div class="d-flex align-items-center" v-if="f.INTESTATARIO"><TestoEspandibile :testo="f.INTESTATARIO" icona="ph-user" /><span class="badge bg-light text-muted ms-1 flex-shrink-0">{{ f.TIPO_INTESTATARIO }}</span></div></td>
								<td class="td-class fs-sm" style="max-width: 0;"><TestoEspandibile :testo="f.DESCRIZIONE" /></td>
								<td class="td-class fs-sm text-end">{{ f.DIVISA }} {{ filters.formattaImporto(f.IMPORTO_NETTO) }}</td>
								<td class="td-class fs-sm text-end">{{ f.DIVISA }} {{ filters.formattaImporto(f.IMPORTO_IVA) }}</td>
								<td class="td-class fs-sm text-end fw-semibold">{{ f.DIVISA }} {{ filters.formattaImporto(f.IMPORTO_TOTALE) }}</td>
								<td class="td-class fs-sm text-end">&euro; {{ filters.formattaImporto(f.IMPORTO_ASSOCIATO) }} <small class="text-muted">({{ f.NUM_ASSOCIATI }})</small></td>
								<td class="td-class text-center">
									<span class="badge" :class="f.RESIDUO > 0 ? 'bg-warning text-dark' : 'bg-success'" :title="'Residuo € ' + filters.formattaImporto(f.RESIDUO)">{{ percDaAssociare(f) }}%</span>
								</td>
								<td class="td-class text-center" v-if="tab == 1">
									<a v-if="f.FLG_ELIMINATO != 1 && $root.hasFunzionalita('SCADENZARI_READ')" href="#" class="badge" :class="f.N_SCADENZE == 0 ? 'bg-light text-muted' : (f.N_SCADENZE_PAGATE == f.N_SCADENZE ? 'bg-success' : 'bg-info')" title="Scadenze pagate / totali" @click.prevent="apriScadenze(f)">{{ f.N_SCADENZE == 0 ? 'Nessuna' : f.N_SCADENZE_PAGATE + '/' + f.N_SCADENZE }}</a>
								</td>
								<td class="td-class text-center">
									<div class="dropdown">
										<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false"><i class="ph-list"></i></a>
										<div class="dropdown-menu dropdown-menu-end">
											<template v-if="f.FLG_ELIMINATO != 1">
											<a href="#" class="dropdown-item" v-on:click.prevent="modificaFattura(f)"><i class="fad fa-pencil fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Apri / associa {{ cfgRighe.righe }}</a>
											<a href="#" class="dropdown-item" v-if="tab == 1 && $root.hasFunzionalita('SCADENZARI_READ')" v-on:click.prevent="apriScadenze(f)"><i class="fad fa-calendar-alt fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Scadenze</a>
											<a href="#" class="dropdown-item" v-if="f.FILE_ALLEGATO || $root.hasFunzionalita('FATTURAZIONE_UPDATE')" v-on:click.prevent="apriAllegato(f)"><i class="fad fa-paperclip fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Allegato</a>
											<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('FATTURAZIONE_DELETE')" v-on:click.prevent="elimina([f])"><i class="fad fa-trash fa-lg fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span>Elimina</a>
											</template>
											<a href="#" class="dropdown-item text-success" v-if="$root.isGod && f.FLG_ELIMINATO == 1" v-on:click.prevent="ripristina([f])"><i class="fad fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate></a>
										</div>
									</div>
								</td>
							</tr>
							<tr v-if="paginatedList.count == 0"><td :colspan="tab == 1 ? 12 : 11" class="text-muted fs-sm">Nessuna fattura</td></tr>
						</tbody>
					</table>
				</div>

				<div class="row page-bottom">
					<div class="col-12 col-md-5 d-none d-sm-block">
						<div style="position: relative; top: 10px;">
							<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">FATTURE: {{ paginatedList.count }}</span>						</div>
					</div>
					<div class="col-9 col-md-6">
						<div class="float-end pag-mobile">
							<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
						</div>
					</div>
					<div class="col-3 col-md-1">
						<select class="form-select form-select-sm wmin-100 mt-2 float-end" v-model="search.PAGINATION.PAGE_SIZE">
							<option value="10">10</option>
							<option value="25">25</option>
							<option value="50">50</option>
							<option value="100">100</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE FATTURA -->
	<div class="modal fade" id="popUpFattura" role="dialog" tabindex="-1">
		<div class="modal-dialog modal-xl modal-dialog-scrollable">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">
						<i class="far fa-file-invoice fa-fw fa-lg me-1"></i>
						{{ fattura.ID_FATTURA > 0 ? 'Fattura n. ' + fattura.NUMERO : 'Nuova fattura ' + cfgRighe.fattura }}
					</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-12 col-md-4 mb-2">
							<label class="form-label">Intestatario *</label>
							<SelectIntestatario v-model:pg="fattura.FK_ID_PERSONA_GIURIDICA" v-model:pf="fattura.FK_ID_PERSONA_FISICA" :api-aziende="apiAziende" :disabled="fattura.IMPORTO_ASSOCIATO > 0" :placeholder="'Seleziona'"></SelectIntestatario>
						</div>
						<div class="col-6 col-md-2 mb-2">
							<label class="form-label">Numero *</label>
							<input type="text" class="form-control form-control-sm" v-model="fattura.NUMERO" autocomplete="off">
						</div>
						<div class="col-6 col-md-2 mb-2">
							<label class="form-label">Data *</label>
							<Datepicker v-model="fattura.DATA_FATTURA" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :enable-time-picker="false" placeholder="Data" />
						</div>
						<div class="col-12 col-md-4 mb-2">
							<label class="form-label">Descrizione</label>
							<input type="text" class="form-control form-control-sm" v-model="fattura.DESCRIZIONE" autocomplete="off">
						</div>
						<div class="col-4 col-md-1 mb-2">
							<label class="form-label">Valuta</label>
							<SelectValuta v-model="fattura.DIVISA"></SelectValuta>
						</div>
						<div class="col-4 col-md-2 mb-2">
							<label class="form-label">Netto</label>
							<input type="text" inputmode="decimal" class="form-control form-control-sm text-end" v-model="fattura.IMPORTO_NETTO" @blur="normalizza(fattura, 'IMPORTO_NETTO')">
						</div>
						<div class="col-4 col-md-2 mb-2">
							<label class="form-label text-nowrap">IVA ({{ fattura.DIVISA }} {{ filters.formattaImporto(ivaFattura) }})</label>
							<select class="form-select form-select-sm" v-model="fattura.FK_ID_IVA">
								<option :value="0">— Nessuna —</option>
								<option v-for="c in filters.getCodiciIvaAttivi()" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ID_OPZIONE_TIPOLOGICA">{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}</option>
							</select>
						</div>
						<div class="col-4 col-md-2 mb-2">
							<label class="form-label">Totale</label>
							<input type="text" class="form-control form-control-sm text-end fw-semibold" :value="filters.formattaImporto(totaleFattura)" disabled>
						</div>
						<div class="col-12 col-md-4 mb-2">
							<label class="form-label">Note</label>
							<input type="text" class="form-control form-control-sm" v-model="fattura.NOTE" autocomplete="off">
						</div>
						<div class="col-12 col-md-1 mb-2">
							<label class="form-label">Attiva</label>
							<ISwitch :size="'sm'" v-model="fattura.FLG_ATTIVO"></ISwitch>
						</div>
					</div>

					<template v-if="fattura.ID_FATTURA > 0">
						<hr>
						<div class="d-flex align-items-center mb-2">
							<h6 class="fw-semibold mb-0">{{ cfgRighe.titolo }} coperti da questa fattura</h6>
							<span class="badge ms-auto p-2" :class="residuoFattura > 0 ? 'bg-warning text-dark' : 'bg-success'">
								Da associare: &euro; {{ filters.formattaImporto(residuoFattura) }}
							</span>
						</div>
						<div class="row g-2 mb-2">
							<div class="col-12 col-md-3">
								<input type="text" class="form-control form-control-sm" placeholder="Cerca commessa" v-model="searchRighe.COMMESSA_LABEL.VALUE" autocomplete="off">
							</div>
							<div class="col-12 col-md-3">
								<input type="text" class="form-control form-control-sm" placeholder="Cerca descrizione" v-model="searchRighe.DESCRIZIONE.VALUE" autocomplete="off">
							</div>
							<div class="col-12 col-md-2">
								<select class="form-select form-select-sm" v-model="searchRighe.STATO_FATTURA.VALUE">
									<option value="">Tutti gli stati</option>
									<option value="DA">Da fatturare</option>
									<option value="PARZIALE">Fatturati in parte</option>
									<option value="CHIUSA">Chiusi da questa fattura</option>
								</select>
							</div>
							<div class="col-6 col-md-2">
								<input type="text" inputmode="decimal" class="form-control form-control-sm text-end" placeholder="Importo da €" v-model="searchRighe.IMPORTO.VALUE_FROM" @blur="normalizzaRange('VALUE_FROM')">
							</div>
							<div class="col-6 col-md-2">
								<input type="text" inputmode="decimal" class="form-control form-control-sm text-end" placeholder="Importo a €" v-model="searchRighe.IMPORTO.VALUE_TO" @blur="normalizzaRange('VALUE_TO')">
							</div>
						</div>
						<div style="max-height: 45vh; overflow-y: auto;">
							<table class="table table-sm table-hover mb-0">
								<thead class="sticky-top bg-white">
									<tr>
										<th>Commessa</th>
										<th>Descrizione</th>
										<th class="text-end" style="width:12%;">Importo con IVA</th>
										<th class="text-end" style="width:12%;">Ancora da fatturare</th>
										<th class="text-end" style="width:15%;">Su questa fattura</th>
										<th class="text-center" style="width:8%;"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="r in paginatedRighe.arr" :key="r[cfgRighe.chiave]">
										<td class="fs-sm" style="max-width: 0;"><TestoEspandibile v-if="r.COMMESSA_TIPO" :testo="r.COMMESSA_LABEL || r.COMMESSA_TIPO + ' ' + r.COMMESSA_ID" icona="ph-briefcase" /><span v-else>Generale</span></td>
										<td class="fs-sm" style="max-width: 0;"><TestoEspandibile :testo="r.DESCRIZIONE" /><TestoEspandibile v-if="r.ORIGINE_LABEL" class="text-muted fs-xs" :testo="r.ORIGINE_LABEL" icona="ph-link" /></td>
										<td class="text-end fs-sm">&euro; {{ filters.formattaImporto(r.IMPORTO) }}</td>
										<td class="text-end fs-sm">&euro; {{ filters.formattaImporto(r.RESIDUO) }} <small class="text-muted">({{ percDaAssociare(r) }}%)</small></td>
										<td><input type="text" inputmode="decimal" class="form-control form-control-sm text-end" v-model="r.IMPORTO_ASSOCIA" @blur="r.IMPORTO_ASSOCIA !== '' && normalizza(r, 'IMPORTO_ASSOCIA')"></td>
										<td class="text-center text-nowrap">
											<a href="#" title="Salva" class="me-2" v-if="$root.hasFunzionalita(cfgRighe.permesso + (r.ID_ASSOCIAZIONE > 0 ? '_UPDATE' : '_CREATE'))" @click.prevent="salvaAssociazione(r)"><i class="ph-floppy-disk"></i></a>
											<a href="#" v-if="r.ID_ASSOCIAZIONE > 0 && $root.hasFunzionalita(cfgRighe.permesso + '_DELETE')" class="text-danger" title="Togli" @click.prevent="eliminaAssociazione(r)"><i class="ph-trash"></i></a>
										</td>
									</tr>
									<tr v-if="paginatedRighe.count == 0"><td colspan="6" class="text-muted fs-sm">{{ righeAperte.length == 0 ? 'Nessun ' + cfgRighe.riga + ' aperto per questo intestatario' : 'Nessuna riga corrisponde ai filtri' }}</td></tr>
								</tbody>
							</table>
						</div>
						<div class="d-flex align-items-center mt-2">
							<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">{{ cfgRighe.titolo.toUpperCase() }}: {{ paginatedRighe.count }}</span>
							<span class="fs-sm text-muted ms-3">Importo <strong class="text-body">&euro; {{ filters.formattaImporto(totaliRighe.IMPORTO) }}</strong></span>
							<span class="fs-sm text-muted ms-3">Ancora da fatturare <strong class="text-body">&euro; {{ filters.formattaImporto(totaliRighe.RESIDUO) }}</strong></span>
							<span class="fs-sm text-muted ms-3">Su questa fattura <strong class="text-body">&euro; {{ filters.formattaImporto(totaliRighe.IMPORTO_SALVATO) }}</strong></span>
							<div class="ms-auto">
								<Pagine v-model="searchRighe.PAGINATION.PAGE_NUMBER" :numrighe="paginatedRighe.count" :numpagine="searchRighe.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
							</div>
						</div>
					</template>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="ph-x me-1"></i>Annulla</button>
					<template v-if="$root.hasFunzionalita(fattura.ID_FATTURA > 0 ? 'FATTURAZIONE_UPDATE' : 'FATTURAZIONE_CREATE')">
						<button type="button" class="btn btn-sm btn-secondary" @click="salvaFattura(false)"><i class="ph-check me-1"></i>Salva e chiudi</button>
						<button type="button" class="btn btn-sm btn-primary" @click="salvaFattura(true)"><i class="ph-check me-1"></i>Salva e continua</button>
					</template>
				</div>
			</div>
		</div>
	</div>

	<PopUpEsportazione id="popUpEsportazioneFatture" @esporta="esportaDati" />

	<!-- MODALE ALLEGATO -->
	<div class="modal fade" id="popUpAllegatoFattura" role="dialog" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title"><i class="far fa-paperclip fa-fw fa-lg me-1"></i> Allegato fattura n. {{ fatturaAllegato.NUMERO }} · {{ fatturaAllegato.INTESTATARIO }}</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div v-if="fatturaAllegato.FILE_ALLEGATO" class="d-flex align-items-center border rounded p-2 mb-2">
						<i class="ph-file-pdf ph-lg text-danger me-2"></i>
						<a href="#" class="flex-fill text-truncate" @click.prevent="visualizzaAllegato(fatturaAllegato)">{{ fatturaAllegato.NOME_FILE }}</a>
						<button type="button" class="btn btn-flat-danger btn-sm ms-2" v-if="$root.hasFunzionalita('FATTURAZIONE_UPDATE')" @click="eliminaAllegato()"><i class="ph-trash"></i></button>
					</div>
					<p v-else class="text-muted fs-sm">Nessun allegato.</p>
					<div v-if="$root.hasFunzionalita('FATTURAZIONE_UPDATE')" class="d-flex flex-column align-items-center">
						<small class="text-muted mb-1">{{ fatturaAllegato.FILE_ALLEGATO ? 'Caricando un nuovo file sostituisci quello attuale' : 'PDF, XML, P7M o immagine' }}</small>
						<Upload :key="fatturaAllegato.ID_FATTURA + '_' + fatturaAllegato.FILE_ALLEGATO" url="core/basic/upload" :args="{ modalita: 'SHARED_uploadAllegatoFattura', ID_FATTURA: fatturaAllegato.ID_FATTURA }" @onsuccess="dopoAllegato()" @onerror="utils.alert.warning('Errore nel caricamento')" />
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE SCADENZE -->
	<div class="modal fade" id="popUpScadenze" role="dialog" tabindex="-1">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title"><i class="far fa-calendar-alt fa-fw fa-lg me-1"></i> Scadenze fattura n. {{ fatturaScadenze.NUMERO }} · {{ fatturaScadenze.INTESTATARIO }}</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="d-flex align-items-center mb-2">
						<span class="badge p-2" :class="residuoScadenze > 0 ? 'bg-warning text-dark' : 'bg-success'">
							Pianificato &euro; {{ filters.formattaImporto(fatturaScadenze.IMPORTO_TOTALE - residuoScadenze) }} / {{ filters.formattaImporto(fatturaScadenze.IMPORTO_TOTALE) }}
						</span>
						<button type="button" class="btn btn-outline-success btn-sm ms-auto" v-if="$root.hasFunzionalita('SCADENZARI_CREATE') && residuoScadenze > 0" @click="nuovaScadenza()"><i class="ph-plus me-1"></i>Aggiungi scadenza</button>
					</div>
					<table class="table table-sm table-hover mb-0">
						<thead>
							<tr>
								<th style="width:22%;">Scadenza</th>
								<th class="text-end" style="width:18%;">Importo</th>
								<th>Note</th>
								<th class="text-center" style="width:14%;">Stato</th>
								<th class="text-center" style="width:8%;"></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="r in scadenze" :key="r.ID_SCADENZA || r.TEMP_ID">
								<template v-if="r.FK_ID_MOVIMENTO > 0">
									<td class="fs-sm">{{ r.DATA_SCADENZA_IT }}</td>
									<td class="fs-sm text-end">&euro; {{ r.IMPORTO }}</td>
									<td class="fs-sm">{{ r.NOTE }}</td>
									<td class="text-center"><span class="badge bg-success" :title="r.DATA_PAGAMENTO_IT + ' · ' + r.CONTO">Pagata</span></td>
									<td></td>
								</template>
								<template v-else>
									<td><Datepicker v-model="r.DATA_SCADENZA" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :enable-time-picker="false" :clearable="false" /></td>
									<td><input type="text" inputmode="decimal" class="form-control form-control-sm text-end" v-model="r.IMPORTO" @blur="normalizza(r, 'IMPORTO')"></td>
									<td><input type="text" class="form-control form-control-sm" v-model="r.NOTE" autocomplete="off"></td>
									<td class="text-center"><span class="badge" :class="r.STATO == 2 ? 'bg-danger' : 'bg-warning text-dark'">{{ r.ID_SCADENZA > 0 ? (r.STATO == 2 ? 'Scaduta' : 'Da pagare') : 'Nuova' }}</span></td>
									<td class="text-center text-nowrap">
										<a href="#" title="Salva" class="me-2" v-if="$root.hasFunzionalita(r.ID_SCADENZA > 0 ? 'SCADENZARI_UPDATE' : 'SCADENZARI_CREATE')" @click.prevent="salvaScadenza(r)"><i class="ph-floppy-disk"></i></a>
										<a href="#" title="Elimina" class="text-danger" v-if="r.ID_SCADENZA > 0 && $root.hasFunzionalita('SCADENZARI_DELETE')" @click.prevent="eliminaScadenza(r)"><i class="ph-trash"></i></a>
									</td>
								</template>
							</tr>
							<tr v-if="scadenze.length == 0"><td colspan="5" class="text-muted fs-sm">Nessuna scadenza: aggiungine una (precompilata col totale da pagare)</td></tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer bg-light">
					<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">CHIUDI</button>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

import Pagine from '@/components/utils/Pagine.vue'
import SelectIntestatario from '@/components/common/SelectIntestatario.vue'
import SelectValuta from '@/components/common/SelectValuta.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import PopUpEsportazione from '@/components/common/PopUpEsportazione.vue'
import TestoEspandibile from '@/components/common/TestoEspandibile.vue'
import KpiCard from '@/components/dashboard/KpiCard.vue'
import Upload from '@/components/utils/Upload.vue'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

export default {
	name: "Invoice",

	components: { Pagine, SelectIntestatario, SelectValuta, Datepicker, ISwitch, PopUpEsportazione, TestoEspandibile, Upload, KpiCard },

	data: function () {
		return {
			filters: global.filters,
			tab: 1,
			anno: new Date().getFullYear(),
			filtroPg: 0,
			filtroPf: 0,
			eliminati: 0,
			esportazioneTipo: '',
			arrayFatture: [],
			fattura: {},
			righeAperte: [],
			fatturaScadenze: {},
			fatturaAllegato: {},
			utils: global.utils,
			scadenze: [],
			searchRighe: this.nuovaSearchRighe(),
			search: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				NUMERO: { TYPE: 'TEXT', VALUE: '' },
				DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
				FLG_ATTIVO: { TYPE: 'COMBO', VALUE: '1' },
			},
		}
	},

	computed: {
		anni() {
			const oggi = new Date().getFullYear();
			return Array.from({ length: 6 }, (x, i) => oggi - i);
		},
		paginatedList() {
			return utils.inGrid(this.arrayFatture, this.search);
		},
		kpi() {
			const attive = this.arrayFatture.filter(f => f.FLG_ELIMINATO != 1 && f.FLG_ATTIVO == 1);
			const somma = (campo) => utils.array.sumByField(attive, campo);
			const daImputare = attive.filter(f => f.RESIDUO > 0);
			const daScadenzare = attive.filter(f => f.IMPORTO_TOTALE - f.IMPORTO_SCADENZE > 0);
			return [
				{ label: 'Totale fatture', valore: somma('IMPORTO_TOTALE'), tema: 'blue', icona: 'ph-receipt', nota: attive.length + ' fatture, imponibile € ' + this.filters.formattaImporto(somma('IMPORTO_NETTO')) },
				{ label: 'IVA', valore: somma('IMPORTO_IVA'), tema: 'purple', icona: 'ph-percent', nota: 'Sul totale delle fatture' },
				{ label: 'Da associare', valore: utils.array.sumByField(daImputare, 'RESIDUO'), tema: 'red', icona: 'ph-warning-circle', nota: daImputare.length + ' fatture con ' + this.cfgRighe.righe + ' da associare' },
				this.tab == 1
					? { label: 'Da mettere in scadenza', valore: daScadenzare.reduce((tot, f) => tot + (f.IMPORTO_TOTALE - f.IMPORTO_SCADENZE), 0), tema: 'green', icona: 'ph-calendar', nota: daScadenzare.length + ' fatture senza piano completo' }
					: { label: 'Associato agli incassi', valore: somma('IMPORTO_ASSOCIATO'), tema: 'green', icona: 'ph-check-circle', nota: 'Quota delle fatture coperta da incassi' },
			];
		},
		// Acquisto ↔ costi (fornitori), vendita ↔ incassi (clienti): API del pacchetto contabilità
		cfgRighe() {
			return this.tab == 1
				? { modulo: 'costi', titolo: 'Costi', riga: 'costo', righe: 'costi', chiave: 'ID_COSTO', fk: 'FK_ID_COSTO', permesso: 'COSTI', fattura: "d'acquisto" }
				: { modulo: 'incassi', titolo: 'Incassi', riga: 'incasso', righe: 'incassi', chiave: 'ID_INCASSO', fk: 'FK_ID_INCASSO', permesso: 'INCASSI', fattura: 'di vendita' };
		},
		apiAziende() {
			return 'shared-s2/aziende?TIPO=' + (this.tab == 1 ? 2 : 1);
		},
		ivaFattura() {
			return this.filters.ivaSuImponibile(this.filters.parseImporto(this.fattura.IMPORTO_NETTO), this.fattura.FK_ID_IVA);
		},
		totaleFattura() {
			return this.filters.parseImporto(this.fattura.IMPORTO_NETTO) + this.ivaFattura;
		},
		paginatedRighe() {
			return utils.inGrid(this.righeAperte, this.searchRighe);
		},
		// Totali di tutte le righe che passano i filtri, non solo della pagina
		totaliRighe() {
			const righe = utils.filter(this.righeAperte, this.searchRighe);
			const somma = (campo) => Math.round(utils.array.sumByField(righe, campo) * 100) / 100;
			return { IMPORTO: somma('IMPORTO'), RESIDUO: somma('RESIDUO'), IMPORTO_SALVATO: somma('IMPORTO_SALVATO') };
		},
		residuoScadenze() {
			const salvate = this.scadenze.filter(r => r.ID_SCADENZA > 0).reduce((tot, r) => tot + parseFloat(r.IMPORTO_SALVATO), 0);
			return Math.round((parseFloat(this.fatturaScadenze.IMPORTO_TOTALE || 0) - salvate) * 100) / 100;
		},
		residuoFattura() {
			return Math.round((this.totaleFattura - utils.array.sumByField(this.righeAperte.filter(r => r.ID_ASSOCIAZIONE > 0), 'IMPORTO_SALVATO')) * 100) / 100;
		},
	},

	methods: {
		getFatture(dopo) {
			utils.ajax('shared/fatturazione/lista', { FLG_TIPO: this.tab, ANNO: this.anno, FK_ID_PERSONA_GIURIDICA: this.filtroPg || 0, FK_ID_PERSONA_FISICA: this.filtroPf || 0, ELIMINATI: this.eliminati }, (response) => {
				this.arrayFatture = response.data;
				if (dopo) dopo();
			}, true, 0, 'GET');
		},

		nuovaFattura() {
			this.fattura = { ID_FATTURA: 0, FLG_TIPO: this.tab, FK_ID_PERSONA_GIURIDICA: this.filtroPg || 0, FK_ID_PERSONA_FISICA: this.filtroPf || 0, NUMERO: '', DATA_FATTURA: new Date(), DESCRIZIONE: '', IMPORTO_NETTO: '', FK_ID_IVA: 0, DIVISA: 'EUR', NOTE: '', FLG_ATTIVO: 1, IMPORTO_ASSOCIATO: 0 };
			this.righeAperte = [];
			this.searchRighe = this.nuovaSearchRighe();
			this.filters.openPopUp('popUpFattura');
		},

		modificaFattura(f) {
			this.fattura = utils.clone(f);
			this.righeAperte = [];
			this.searchRighe = this.nuovaSearchRighe();
			this.normalizza(this.fattura, 'IMPORTO_NETTO');
			this.fattura.FK_ID_IVA = parseInt(f.FK_ID_IVA) || 0;
			this.getRigheAperte();
			this.filters.openPopUp('popUpFattura');
		},

		salvaFattura(continua = false) {
			const params = utils.clone(this.fattura);
			params.DATA_FATTURA = this.filters.formatDateOnly(this.fattura.DATA_FATTURA);
			params.IMPORTO_NETTO = this.filters.parseImporto(this.fattura.IMPORTO_NETTO);
			params.IMPORTO_IVA = this.ivaFattura;
			const nuova = !(params.ID_FATTURA > 0);
			const api = nuova ? 'shared/fatturazione/insert' : 'shared/fatturazione/update';
			utils.ajax(api, params, (response) => {
				utils.alert.success(response.messaggio);
				this.getFatture();
				if (!continua) {
					this.filters.closePopUp('popUpFattura');
					return;
				}
				if (nuova) {
					this.fattura.ID_FATTURA = response.id_inserito;
				}
				this.fattura.IMPORTO_TOTALE = this.totaleFattura;
				this.getRigheAperte();
			}, true, 0, nuova ? 'POST' : 'PUT');
		},

		eliminaSelezionate() {
			this.elimina(this.arrayFatture.filter(f => f.SELEZIONATO == 1 && f.FLG_ELIMINATO != 1));
		},

		elimina(righe) {
			if (righe.length == 0) { utils.alert.warning('Nessuna fattura selezionata.'); return; }
			utils.alert.confirm(righe.length == 1 ? 'Eliminare la fattura n. ' + righe[0].NUMERO + '?' : 'Eliminare ' + righe.length + ' fatture?', () => {
				utils.ajax('shared/fatturazione/delete', { IDS: righe.map(f => f.ID_FATTURA) }, (response) => {
					utils.alert.success(response.messaggio);
					this.getFatture();
				}, true, 0, 'DELETE');
			}, this.$root);
		},

		ripristinaSelezionate() {
			this.ripristina(this.arrayFatture.filter(f => f.SELEZIONATO == 1 && f.FLG_ELIMINATO == 1));
		},

		ripristina(righe) {
			utils.alert.confirm(righe.length == 1 ? 'Ripristinare la fattura n. ' + righe[0].NUMERO + '?' : 'Ripristinare ' + righe.length + ' fatture?', () => {
				utils.ajax('shared/fatturazione/ripristina', { IDS: righe.map(f => f.ID_FATTURA) }, (response) => {
					utils.alert.success(response.messaggio);
					this.getFatture();
				}, true, 0, 'PUT');
			}, this.$root);
		},

		apriEsportazione(tipo) {
			this.esportazioneTipo = tipo;
			this.filters.openPopUp('popUpEsportazioneFatture');
		},

		esportaDati(formato) {
			utils.esportaTabella({ tipo: this.esportazioneTipo, formato: formato, arrayCompleto: this.arrayFatture, arrayPagina: this.paginatedList.arr, idField: 'ID_FATTURA', modulo: 'fatture' });
		},

		cambiaTab(tab) {
			if (this.tab == tab) return;
			this.tab = tab;
			this.filtroPg = 0;
			this.filtroPf = 0;
			this.search.PAGINATION.PAGE_NUMBER = 1;
			this.arrayFatture = [];
			this.getFatture();
		},

		percDaAssociare(r) {
			const totale = parseFloat(r.IMPORTO_TOTALE ?? r.IMPORTO) || 0;
			return totale > 0 ? Math.round(r.RESIDUO / totale * 1000) / 10 : 0;
		},

		apiRighe(operazione) {
			return 'shared/' + this.cfgRighe.modulo + '/' + operazione;
		},

		// Costi/incassi aperti dell'intestatario + quanto di ciascuno è già su questa fattura
		getRigheAperte(salvata = null) {
			const idFattura = this.fattura.ID_FATTURA;
			const pg = parseInt(this.fattura.FK_ID_PERSONA_GIURIDICA) || 0, pf = parseInt(this.fattura.FK_ID_PERSONA_FISICA) || 0;
			if (pg == 0 && pf == 0) { this.righeAperte = []; return; }
			const { chiave, fk } = this.cfgRighe;
			utils.ajax(this.apiRighe('associazione'), { FK_ID_FATTURA: idFattura }, (response) => {
				const associazioni = response.data;
				utils.ajax(this.apiRighe('lista'), { FK_ID_PERSONA_GIURIDICA: pg, FK_ID_PERSONA_FISICA: pf }, (resp) => {
					const nuove = resp.data.filter(r => r.RESIDUO > 0 || associazioni.some(a => a[fk] == r[chiave])).map(r => {
						const a = associazioni.find(a => a[fk] == r[chiave]);
						// DA = nessuna fattura, CHIUSA = coperto tutto (i chiusi caricati sono solo quelli su questa fattura), PARZIALE = il resto
						const stato = parseFloat(r.ASSOCIATO) == 0 ? 'DA' : (parseFloat(r.RESIDUO) <= 0 ? 'CHIUSA' : 'PARZIALE');
						return { ...r, STATO_FATTURA: stato, ID_ASSOCIAZIONE: a ? a.ID_ASSOCIAZIONE : 0, IMPORTO_ASSOCIA: a ? this.filters.formattaImporto(a.IMPORTO) : '', IMPORTO_SALVATO: a ? a.IMPORTO : 0 };
					});
					// Senza riga salvata è un'apertura: niente da conservare
					this.righeAperte = salvata ? utils.array.mantieniRighe(nuove, this.righeAperte, chiave, salvata) : nuove;
				}, true, 0, 'GET');
			}, true, 0, 'GET');
		},

		salvaAssociazione(r) {
			const params = { [this.cfgRighe.fk]: r[this.cfgRighe.chiave], FK_ID_FATTURA: this.fattura.ID_FATTURA, IMPORTO: this.filters.parseImporto(r.IMPORTO_ASSOCIA) };
			if (r.ID_ASSOCIAZIONE > 0) params.ID_ASSOCIAZIONE = r.ID_ASSOCIAZIONE;
			utils.ajax(this.apiRighe('associazione'), params, (response) => {
				utils.alert.success(response.messaggio);
				this.getRigheAperte(r);
				this.getFatture();
			}, true, 0, r.ID_ASSOCIAZIONE > 0 ? 'PUT' : 'POST');
		},

		eliminaAssociazione(r) {
			utils.ajax(this.apiRighe('associazione'), { ID_ASSOCIAZIONE: r.ID_ASSOCIAZIONE }, (response) => {
				utils.alert.success(response.messaggio);
				this.getRigheAperte(r);
				this.getFatture();
			}, true, 0, 'DELETE');
		},

		nuovaSearchRighe() {
			return {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 10 },
				COMMESSA_LABEL: { TYPE: 'TEXT', VALUE: '' },
				DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
				STATO_FATTURA: { TYPE: 'COMBO', VALUE: '' },
				IMPORTO: { TYPE: 'INT_RANGE', VALUE_FROM: '', VALUE_TO: '' },
			};
		},

		// Il filtro INT_RANGE confronta numeri: "1.000" scritto all'italiana diventa 1000
		normalizzaRange(campo) {
			const r = this.searchRighe.IMPORTO;
			if (r[campo] !== '') r[campo] = this.filters.parseImporto(r[campo]);
		},

		// Riscrive l'importo come lo ha capito il sistema ("25.552" -> "25.552,00"), cosi' l'utente lo vede subito
		normalizza(obj, campo) {
			obj[campo] = this.filters.formattaImporto(this.filters.parseImporto(obj[campo]));
		},

		apriAllegato(f) {
			this.fatturaAllegato = utils.clone(f);
			this.filters.openPopUp('popUpAllegatoFattura');
		},

		visualizzaAllegato(f) {
			utils.ajaxBlob('shared/fatturazione/allegato', { ID_FATTURA: f.ID_FATTURA }, (blob) => {
				window.open(URL.createObjectURL(blob), '_blank');
			}, true, 'GET');
		},

		// Dopo upload o eliminazione si rilegge la lista e si aggiorna la modale con la riga nuova
		dopoAllegato() {
			utils.alert.success('Allegato salvato');
			this.getFatture(() => {
				this.fatturaAllegato = utils.clone(this.arrayFatture.find(f => f.ID_FATTURA == this.fatturaAllegato.ID_FATTURA) || this.fatturaAllegato);
			});
		},

		eliminaAllegato() {
			utils.alert.confirm('Eliminare l\'allegato ' + this.fatturaAllegato.NOME_FILE + '?', () => {
				utils.ajax('shared/fatturazione/allegato-elimina', { ID_FATTURA: this.fatturaAllegato.ID_FATTURA }, () => this.dopoAllegato(), true, 0, 'PUT');
			}, this.$root);
		},

		apriScadenze(f) {
			this.fatturaScadenze = utils.clone(f);
			this.scadenze = [];
			this.getScadenze();
			this.filters.openPopUp('popUpScadenze');
		},

		getScadenze(salvata = null) {
			utils.ajax('shared/scadenzari/lista', { FK_ID_FATTURA: this.fatturaScadenze.ID_FATTURA }, (response) => {
				const nuove = response.data.map(r => ({ ...r, DATA_SCADENZA: new Date(r.DATA_SCADENZA), IMPORTO_SALVATO: r.IMPORTO, IMPORTO: this.filters.formattaImporto(r.IMPORTO) }));
				this.scadenze = utils.array.mantieniRighe(nuove, this.scadenze, 'ID_SCADENZA', salvata);
			}, true, 0, 'GET');
		},

		// Prima scadenza: data fattura; le successive un mese dopo l'ultima. Importo = quanto resta da pianificare
		nuovaScadenza() {
			const ultima = this.scadenze.length > 0 ? new Date(this.scadenze[this.scadenze.length - 1].DATA_SCADENZA) : null;
			const scadenza = ultima ? new Date(ultima.setMonth(ultima.getMonth() + 1)) : new Date(this.fatturaScadenze.DATA_FATTURA);
			const bozze = this.scadenze.filter(r => !(r.ID_SCADENZA > 0)).reduce((tot, r) => tot + this.filters.parseImporto(r.IMPORTO), 0);
			const importo = Math.max(Math.round((this.residuoScadenze - bozze) * 100) / 100, 0);
			this.scadenze.push({ ID_SCADENZA: 0, TEMP_ID: new Date().getTime(), FK_ID_FATTURA: this.fatturaScadenze.ID_FATTURA, DATA_SCADENZA: scadenza, IMPORTO: this.filters.formattaImporto(importo), NOTE: '', FK_ID_MOVIMENTO: 0, IMPORTO_SALVATO: 0 });
		},

		salvaScadenza(r) {
			const params = { ID_SCADENZA: r.ID_SCADENZA, FK_ID_FATTURA: r.FK_ID_FATTURA, DATA_SCADENZA: this.filters.formatDateOnly(r.DATA_SCADENZA), IMPORTO: this.filters.parseImporto(r.IMPORTO), NOTE: r.NOTE };
			utils.ajax(r.ID_SCADENZA > 0 ? 'shared/scadenzari/update' : 'shared/scadenzari/insert', params, (response) => {
				utils.alert.success(response.messaggio);
				this.getScadenze(r);
				this.getFatture();
			}, true, 0, r.ID_SCADENZA > 0 ? 'PUT' : 'POST');
		},

		eliminaScadenza(r) {
			utils.ajax('shared/scadenzari/delete', { ID_SCADENZA: r.ID_SCADENZA }, (response) => {
				utils.alert.success(response.messaggio);
				this.getScadenze(r);
				this.getFatture();
			}, true, 0, 'DELETE');
		},
	},

	created: function () {
		global.utils.BASE_API = process.env.VUE_APP_API_URL;
		// Da scadenzario, costi o incassi: tipo, anno e numero della fattura nei filtri, mostrata anche se non attiva
		if (this.$route.query.TIPO == 2) this.tab = 2;
		if (this.$route.query.NUMERO) {
			this.anno = parseInt(this.$route.query.ANNO) || this.anno;
			this.search.NUMERO.VALUE = this.$route.query.NUMERO;
			this.search.FLG_ATTIVO.VALUE = '';
		}
		this.getFatture();
	},
}
</script>
